import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import "../../Assets/Styles/Style.css";
import useApi from "../../utils/useApi";

const DescriptionInvestment = ({ data }) => {
  const [customerCharge, setCustomerCharge] = useState(null);
  const { Get } = useApi();

  useEffect(() => {
    const fetchCustomerCharge = async () => {
      try {
        const response = await Get("appEnv");
        const dataArray = response.results || response;
        const chargeItem = dataArray.find(item => item.key === "CUSTOMER_CHARGE");
        if (chargeItem) {
          setCustomerCharge(chargeItem.value);
        }
      } catch (error) {
        console.error('Error fetching customer charge:', error);
      }
    };
    fetchCustomerCharge();
  }, []);

  if (!data) return null; // Handle missing data gracefully
  const { due_summary, group_info, investment_info, personal_info } = data;

  return (
    <>
    
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-12">
            <span className="investment-title" style={{ textAlign: "center", fontSize: '18px', fontFamily: 'Comfortaa' }}>
            {!group_info?.is_dhruv_inv
                ? "P Chandra Investment CO"
                : "Dhruv Investment CO"}
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="investment-card">
              {/* Display table data */}
              <table className="auto-table">
                <thead>
                  <tr className="investment-id-row">
                    <th colSpan={3}>
                      <div className="investment-id">
                        {investment_info.investment_id}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>Group:</strong> <br />
                      {investment_info.group}
                    </td>
                    <td>
                      <strong>Sub No:</strong>
                      <br /> {investment_info.subscription_no}
                    </td>
                    <td>
                      <strong>Total Installment:</strong> <br />
                      {investment_info.total_month}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Paid Installment:</strong>
                      <br />
                      {investment_info.total_passed_months}
                    </td>
                    <td>
                    <strong>Pen After:</strong> <br />
                      {due_summary.no_penalty_till}

                    </td>
                    <td>
                      <strong>Next Due Date:</strong>
                      <br />
                      <u style={{ color: "blue" }}>
                        {due_summary.next_due_date}
                      </u>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <strong>Total Invested:</strong> <br />₹
                      {investment_info.total_invested}
                    </td>
                    <td colSpan={2}>
                    <strong>Address:</strong> <br />
                    {personal_info?.address || "N/A"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-6">
            <div className="data-container">
              <div className="data-item">
                <strong>Current month subscription Amount:</strong>{" "}
                <span className="sub-amt-value">
                  ₹{due_summary.subscription_amt}
                </span>
              </div>
              <div className="data-item">
                <strong>Current Month Penalty:</strong> ₹
                {due_summary.current_month_penalty}
              </div>
              <div className="data-item">
                <strong>Passed month subscription Amount:</strong> ₹
                {due_summary.passed_month_subscription_amt}
              </div>
              <div className="data-item">
                <strong>Passed month Penalty:</strong> ₹
                {due_summary.passed_month_penalty}
              </div>
              <hr />
              <div className="data-item">
                <strong>Total subscription amt to pay:</strong>{" "}
                <spam className="total-pay-amt">
                  ₹
                  {due_summary.passed_month_subscription_amt +
                    due_summary.subscription_amt}
                </spam>
              </div>
              <div className="data-item">
                <strong>Total penalty to pay:</strong>{" "}
                <span className="pen-value">₹{due_summary.total_penalty}</span>
              </div>
              <div className="data-item">
                <strong>Processing Charges</strong>{" "}
                <span className="pen-value">{customerCharge && (
                  <span className="pen-value">
                    {customerCharge}
                  </span>
                )}</span>
              </div>
              <div
                className="data-item"
                style={{
                  border: "2px dashed green",
                  padding: "5px",
                  borderRadius: "10px",
                  backgroundColor: "green",
                  color: "white",
                }}
              >
                <strong>Payable Amount:</strong> ₹{due_summary.payable_amt}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DescriptionInvestment;
